/*
 * NOTE: The Babel plugin will automatically process the `tw()` function, which
 * means we donâ€™t actually need to import it. ESLint will complain about this,
 * however, so we need to add `tw` as a global variable.
 */

/* global tw */
import React from 'react'
import styled from 'styled-components';
import '../assets/fonts/fonts.css';
// import {Parallax, ParallaxLayer} from 'react-spring/dist/addons'
import { css } from 'emotion'
import { injectGlobal } from 'react-emotion';
import { connect } from 'react-redux';
import { navigate } from "gatsby"
import ReactGA from 'react-ga';
import ReactPixel from 'react-facebook-pixel';

import {
  addStop,
  addStopAtIndex,
  editStop,
  pushStopAtIndex,
  updateDestLocation,
  updatePickupLocation,
  updateCityOfStop,
  updateRideDistance,
  updateRideDuration,
  addFirstStop,
  fetchLocationByLatLong,
  updateDestCity,
  updateRideStartDate,
  updateStartTime,
  updateRideEndDate,
  updateEndTime,
  updateTripType,
  removeLastStop,
  updateRentalType,
  updateLeadTime,
  updateHourlyPackage,
  fetchStaticCities,
  updatePickupCity,
  updateAirportType
} from '../actions/rideActions';
import {
  flushCarsState
} from '../actions/carsActions'

import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from 'react-places-autocomplete';
import Geocode from "react-geocode";
import Moment from 'moment';
import {
  BrowserView,
  MobileView,
  isBrowser,
  isMobile
} from "react-device-detect";

import NewSectionOne from '../components/NewSectionOne';
import CoronaDisplay from '../components/appComponents/CoronaDisplay'
import SectionOne from '../components/SectionOne';
import SectionTwo from '../components/SectionTwo';
import SectionThree from '../components/SectionThree';
import NavBar from '../components/NavBar';
import SectionFour from '../components/SectionFour';
import SectionFive from '../components/SectionFive';
import SectionSix from '../components/SectionSix';
import Footer from '../components/Footer';
import Helmet from 'react-helmet';
import BlackOverlay from '../components/appComponents/BlackOverlay';
import SliderModal from '../components/appComponents/SliderModal';
import Row from '../components/Row';
import RentingChoiceButton from '../components/appComponents/RentingChoiceButton';

import OSCabIcon from '../assets/img/illustrations/outstationRentals.svg';
import SDCabIcon from '../assets/img/illustrations/selfDrivenRentals.svg'
import ATCabIcon from '../assets/img/illustrations/airportTransfer.svg'
import HRCabIcon from '../assets/img/illustrations/hourlyRentals.svg'
import PlacesModal from '../components/appComponents/PlacesModal';
import DateTime from '../components/appComponents/DateTime';
import PackagesModal from '../components/appComponents/PackagesModal';
import RentingChoicesModal from '../components/appComponents/RentingChoicesModal';
// import CarChoicesModal from '../components/appComponents/CarChoicesModal';
import NewDateTime from '../components/appComponents/NewDateTime';
import { getIP } from '../actions/orderActions';
// import MessengerCustomerChat from 'react-messenger-customer-chat';
import withLocation from "../components/withLocation";
// import { updateFetchVehicles } from '../actions/userActions';
import 'react-slideshow-image/dist/styles.css';
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer,

} = require("react-google-maps");

/* global tw */
const IndexWrapper = styled.div`
  ${tw`relative max-w-screen overflow-x-hidden`};
`

const RentingChoicesWrapper = styled.div`
  ${tw`mx-auto lg:-mx-2 px-8 lg:px-6 pt-2 relative z-0 max-h-full w-full overflow-y-scroll overflow-x-hidden scrolling-touch`};
  -webkit-overflow-scrolling: touch;
`

const RentingChoice = styled.div`
  ${tw` flex items-center flex-wrap bg-grey-light rounded-lg lg:mx-4 px-4 lg:px-12 py-8 my-4 cursor-pointer`};
  transition: all 0.2s ease-in-out;
  height: auto;
  width: 100%;
  @media (min-width: 992px){
    height: 16rem;
    width: calc(25% - 2rem);
  }
  img{
    ${tw`-mt-4 h-16 py-2 px-0 lg:px-2`};
  }
  :hover{
    ${tw`bg-white shadow-md`};

  }
`




const ChoiceDescription = styled.div`
  h3{
    ${tw`m-0 text-xl lg:text-2xl tracking-tight`};
  }
  p{
    ${tw`font-medium text-sm lg:text-md opacity-60`};
  }
`
// Geocode.setApiKey("AIzaSyAEarG8tKd2cFXWtDkAfBOrymFUCfjuFok");

const data = `{
  
"@context": "https://schema.org/",
"@type": "Product",
"name": "ZYPPYS",
"aggregateRating": {
"@type": "AggregateRating",
"ratingValue": "4.9",
"bestRating": "5",
"worstRating": "1",
"ratingCount": "300"  
}
}`

// zyppys portal AIzaSyDmSzYU3JlM-AjP_XL9spDTO2A7iWfilUg
Geocode.setApiKey("AIzaSyDrm-YN3aa0Lj3VMz-hD0_IExL2BYZ06qA");

class index extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      showPlacesModal: false,
      editingStartDate: false,
      editingEndDate: false,
      isPickupEditing: false,
      isDestEditing: false,
      showDatesModal: false,
      showPackagesModal: false,
      showChoiceModal: false,
      isFocus: false,
      date: "",
      popularRoutes: {},
      pickupAddress: null,
      destinationAddress: null,
      pickupLocation: "",
      destLocation: '',
      pickupCity: '',
      destCity: '',
      pickupPlaces: [],
      destPlaces: [],
      address: '',
      readMore: '',
      coronaDisplay: false,
      packageModalType: ''
    }
    this.showTravelChoices = this.showTravelChoices.bind(this);
    this.hideTravelChoices = this.hideTravelChoices.bind(this);
    this.handleRentalTypeChange = this.handleRentalTypeChange.bind(this);
    this.handleFormEdit = this.handleFormEdit.bind(this);
    this.toggleTripType = this.toggleTripType.bind(this);
    this.allFalse = this.allFalse.bind(this);
  }


  handleFormEdit = (type) => {
    window.document.getElementsByTagName("body")[0].style.overflow="hidden";
    // alert(type);
    window.document.getElementsByTagName("body")[0].style.overflow="hidden";
    this.allFalse();
    let self = this;
    if (type === 'pickup') {

      this.setState({
        showOverlay: true,
        showPlacesModal: true,
        editingStartDate: false,
        editingEndDate: false,
        isPickupEditing: true,
        isDestEditing: false,
        showPackagesModal: false,
        isFocus: true,
      }, function () {
        // console.log(JSON.stringify(self.state));
      });

    }
    else if (type === 'dest') {
      this.setState({
        showOverlay: true,
        showPlacesModal: true,
        editingStartDate: false,
        editingEndDate: false,
        isPickupEditing: false,
        isDestEditing: true,
        showPackagesModal: false,
        isFocus: true,
      });
    }
    else if (type === 'startDate') {
      this.setState({
        // showOverlay: true,
        showDatesModal: true,
        editingStartDate: true,
        editingEndDate: false,
        isPickupEditing: false,
        isDestEditing: false,
        showPackagesModal: false,

      });
      if (this.refs.datesStart) {
        this.refs.datesStart.handleClick();
      }
    }
    else if (type === 'endDate') {
      this.setState({
        // showOverlay: true,
        showDatesModal: true,
        editingEndDate: true,
        editingStartDate: false,
        isPickupEditing: false,
        isDestEditing: false,
        showPackagesModal: false,
      });
      if (this.refs.datesEnd) {
        // console.log(this.refs.dates);
        this.refs.datesEnd.handleClick();
      }
    }
    else if (type === 'tripType') {
      this.setState({ isRoundtrip: !this.state.isRoundtrip }, function () {

        //toggling with destination loc
        if (self.props.ride.dest.loc !== "") {
          self.toggleTripType();
        }
      });
    }
    else if (type === 'package') {
      this.setState({
        showOverlay: true,
        showDatesModal: false,
        editingEndDate: false,
        editingStartDate: false,
        isPickupEditing: false,
        isDestEditing: false,
        showPackagesModal: true,
        packageModalType: 'hourly'
      });
    }
    else if (type == 'airportTripType') {
      this.setState({
        showOverlay: true,
        showDatesModal: false,
        editingEndDate: false,
        editingStartDate: false,
        isPickupEditing: false,
        isDestEditing: false,
        showPackagesModal: true,
        packageModalType: 'airport'
      });
    }
  }

  toggleTripType() {
    // if(this.state.rentalType === 2){
    //     alert('Round Trip is mandatory for Self Drive Cars');
    //     return;
    // }
    if (this.props.ride.pickup.loc === "") {
      alert('Please enter your pickup address');
      return;
    }
    if (this.props.ride.dest.loc === "" && (this.props.ride.rentalType === 1 || this.props.ride.rentalType === 3)) {
      alert('Please enter your destination address');
      return;
    }
    let stops = this.props.ride.stops;
    let payLoad = stops[0];
    // console.log(analytics);


    if (this.state.isRoundtrip) {
      // eslint-disable-next-line
      analytics.track('Round Trip', { category: 'clicks' });
      this.props.dispatch(addStop(payLoad));
      this.props.dispatch(updateCityOfStop({ city: payLoad.city, cityLat: payLoad.cityLat, cityLng: payLoad.cityLng }, stops.length));
      this.props.dispatch(updateTripType('Round Trip'));
    }
    else {
      // eslint-disable-next-line
      analytics.track('One Way', { category: 'clicks' });
      this.props.dispatch(removeLastStop())
      this.props.dispatch(updateTripType('One Way'));
    }
  }

  airportTypeChange = (type) => {
    console.log("AIRPORT TYPE",type)
    if (type === 'Airport Pickup')
    {
    this.props.dispatch(updateAirportType('Airport Pickup'))
    }
    else if (type === 'Airport Dropoff')
    {
      this.props.dispatch(updateAirportType('Airport Dropoff'))
    }
    this.setState({ showPackagesModal: false, showOverlay: false });
  }

  handleRentalTypeChange = (type, bool) => {
    this.props.dispatch(flushCarsState());
    let ride = this.props.ride;
    this.setState({ rentalType: type });
    this.props.dispatch(updateRentalType(type));
    if(bool === true){
      this.props.dispatch(updatePickupLocation({
        name: '',
        locLat: '',
        locLng: '',
    }));
    this.props.dispatch(updatePickupCity({
        city: '',
        cityLat: '',
        cityLng: ''
    }));
    this.props.dispatch(updateDestLocation({
        name: '',
        locLat: '',
        locLng: '',
    }));
    this.props.dispatch(updateDestCity({
        city: '',
        cityLat: '',
        cityLng: ''
    }));
    }
    if (type === 1) {
      this.props.dispatch(updateLeadTime(2.25));
      if (this.props.ride.dest.loc === "" && this.state.isRoundtrip) {
        this.setState({ isRoundtrip: false });
        this.props.dispatch(updateTripType('Round Trip'));
      }
    }
    else if (type === 2) {
      this.props.dispatch(updateLeadTime(4));
      this.setState({ isRoundtrip: true, endDate: Moment(this.state.startDate).add(24, 'h'), endTime: this.state.startTime }, function () {
        this.props.dispatch(updateRideEndDate(Moment(this.state.endDate).format('DD-MM-YYYY')));
        this.props.dispatch(updateTripType('Round Trip'));
      });
    }
    else if (type === 3) {
      
      // eslint-disable-next-line
      analytics.track('Airport Type Chosen', { category: 'clicks' });
      this.props.dispatch(updateLeadTime(4));
      this.props.dispatch(updateTripType('One Way'));
      // this.setState({ startDate: Moment().add(4,'h'),endDate: Moment(this.state.startDate).add(24, 'h')},function(){
      //     // this.props.dispatch(updateRideEndDate(Moment(this.state.endDate).format('DD-MM-YYYY')));
      //     // this.props.dispatch(updateTripType('Round Trip'));
      // });
    }
    else if (type >= 4) {
      this.props.dispatch(updateLeadTime(4));
      if (type === 4) {
        // eslint-disable-next-line
        analytics.track('Rental Type 2 Hr 20Kms', { category: 'clicks' });
        this.props.dispatch(updateHourlyPackage('2 hrs, 20 kms'));
        // this.setState({ showOverlay: false, showHourlyPackageOptions: false, rentalPackage: '2 hrs, 20kms', endDate: Moment(this.state.startDate).add(24, 'h') });
      }
      else if (type === 5) {
        // eslint-disable-next-line
        analytics.track('Rental Type 4 Hr 40Kms', { category: 'clicks' });
        // this.setState({ showOverlay: false, showHourlyPackageOptions: false, rentalPackage: '4 hrs, 40kms', endDate: Moment(this.state.startDate).add(24, 'h') });
        this.setState({ showPackagesModal: false, showOverlay: false });
        this.props.dispatch(updateHourlyPackage('4 hrs, 40 kms'));
      }
      else if (type === 6) {
        // eslint-disable-next-line
        analytics.track('Rental Type 8 Hr 80Kms', { category: 'clicks' });
        this.props.dispatch(updateHourlyPackage('8 hrs, 80 kms'));
        this.setState({ showPackagesModal: false, showOverlay: false });
        // this.setState({ showOverlay: false, showHourlyPackageOptions: false, rentalPackage: '8 hrs, 80kms', endDate: Moment(this.state.startDate).add(24, 'h') });
      }
      else if (type === 7) {
        // eslint-disable-next-line
        analytics.track('Rental Type 12 Hr 120Kms', { category: 'clicks' });
        this.props.dispatch(updateHourlyPackage('12 hrs, 120 kms'));
        this.setState({ showPackagesModal: false, showOverlay: false });
        // this.setState({ showOverlay: false, showHourlyPackageOptions: false, rentalPackage: '8 hrs, 80kms', endDate: Moment(this.state.startDate).add(24, 'h') });
      }
    }
    this.allFalse();
  }

  componentWillMount() {
    console.log(this.props.uri);

    // if(this.state.coronaDisplay === true) 
    // {
    //   setTimeout(() => this.setState({coronaDisplay: false}),30000)
    // }

    if (isMobile) {
      this.showTravelChoices()
    }

    if(this.state.coronaDisplay === true)
    {
      setTimeout(() => this.setState({coronaDisplay: false}), 1000)

    }

  }
  componentDidUpdate(prevProps, prevState) {
    console.log("showOverlay",prevState)  
    console.log("showOverlayyyyyy", prevState.showOverlay)  

    if(prevState.showOverlay===true) {
      window.document.getElementsByTagName("body")[0].style.overflow="auto";

    }
  }

  componentDidUpdate(prevProps, prevState) {
    console.log("showOverlay",prevState)  
    console.log("showOverlayyyyyy", prevState.showOverlay)  

    if(prevState.showOverlay===true) {
      window.document.getElementsByTagName("body")[0].style.overflow="auto";

    }
  }

  componentDidMount() {
    this.allFalse();
    this.props.dispatch(getIP());
    if (isMobile) {
      this.showTravelChoices()
    }
    if (window.location.href.includes("hyderabad")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Hyderabad", null), 1000)
    }
    else if (window.location.href.includes("bangalore")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Bangalore", null), 1000)
    }
    else if (window.location.href.includes("chennai")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Chennai", null), 1000)
    }
    else if (window.location.href.includes("delhi")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Delhi", null), 1000)
    }
    else if (window.location.href.includes("mumbai")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Mumbai", null), 1000)
    }
    else if (window.location.href.includes("pune")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Pune", null), 1000)
    }
    else if (window.location.href.includes("secunderabad")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Secunderabad", null), 1000)
    }
    else if (window.location.href.includes("ameerpet")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "ameerpet", null), 1000)
    }
    else if (window.location.href.includes("banjara")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Banjara Hills", null), 1000)
    }
    else if (window.location.href.includes("begumpet")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Begumpet", null), 1000)
    }
    else if (window.location.href.includes("Gachibowli")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Gachibowli", null), 1000)
    }
    else if (window.location.href.includes("hitech")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Hitech City", null), 1000)
    }
    else if (window.location.href.includes("kukat")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Kukatpally", null), 1000)
    }
    else if (window.location.href.includes("madhapur")) {
      setTimeout(() => this.handlePlacePress("chauffeur", "Madhapur", null), 1000)
    }


    if (window.location.href.includes(("self"))) {
      this.props.dispatch(updateRentalType(2))
    }
    else if (window.location.href.includes("outstation")) {
      this.props.dispatch(updateRentalType(1))
    } else {
      this.props.dispatch(updateRentalType(6))
    }
    this.props.dispatch(fetchStaticCities());
    // this.props.dispatch(updateFetchVehicles(false))
    // setTimeout(() => {
    //   let trackingId = "UA-69819547-1";
    //   ReactGA.initialize(trackingId);
    //   console.log("IP Address", this.props.ipAddress);
    //   ReactGA.set({
    //     userId: this.props.ipAddress,
    //     // any data that is relevant to the user session
    //     // that you would like to track with google analytics
    //   });
    //   ReactGA.pageview('/');
    //     }, 5000);

    // const options = {
    //         autoConfig: true, 	// set pixel's autoConfig
    //         debug: true, 		// enable logs
    //     };
    //     const pixelId = '2502221063336049';
    //     ReactPixel.init(pixelId, options);
    //     ReactPixel.pageView(); 					// For tracking page view
    //     // ReactPixel.track( event, data ) 		// For tracking default events, more info about events and data https://developers.facebook.com/docs/ads-for-websites/pixel-events/v2.9
    //     ReactPixel.trackCustom( 'pageload', './' ) 	// For tracking custom events
  }



  handlePlacePress = (type, from, to) => {
    this.handleSelect(from, true);
    this.handleSelect(to, false);
  }

  render() {
    return (
      <div>
      <Helmet
          // title = 'Best Self Drive Car Rental in India & Rental Car, Car Rental'
          // title = 'Zyppys - #1 Outstation Car Rental Services in India. Book Zyppys car rentals for hassle-free journeys for family trips and outings with friends!'
          title ='Zyppys offers premium chauffeur-driven luxury car rentals across India, ensuring an unparalleled travel experience with professional service and a curated fleet.Book your ride today!'
          // title = "Self-Drive Car Rental In India : Outstation Cabs | Rent A Car | Car Hire Online | Outstation Taxi Booking Service | Airport Transfers | Book Hourly Rental Car - ZYPPYS"
          meta={[
            { name: 'description', content: 'Best Self Drive Car Rental in India & Rental Car for individual, family, corporate, and Self Drive Cars in India Zyppys is one of the best Self-drives car' },
            // { name: 'description', content: 'Self Drive Car Rental In India - Outstation Cabs - Airport Transfer Services - Hourly Rental Car : Book best Self-drive car rentals online, hire Self drive cars without driver, Outstation cabs, Outstation taxi, Airport transfer services and Hourly rental cars at affordable prices at ZYPPYS in India.' },
            { name: 'keywords', content: 'Zyypys, Car Rental, car rental near me, car rental app, car rental bangalore, car rental hyderabad, Roadtrip, Outstation Cabs, Road Travel, Chauffeur Driven Cars, Rental Cars, Cheap Rental Cars, Vacation Rentals, Outstation Rentals, Bike Rentals, Aha Taxis, Revv, Zoomcar, Avis, Hertz, Gozo Cabs, Savaari, Taxi Bazaar, Quick Ride, Car Pooling, Car sharing, Travel, Road travel, Airport Taxi, Self Drive Cars, Car Rentals, self drive car hire bangalore,self drive car rental bangalore ,self drive hire bangalore, self drive rental bangalore,self drive car hire hyderabad,self drive car rental hyderabad ,self drive hire hyderabad, self drive rental hyderabad,self drive hire cars ,self drive car rental ,self drive hire , self drive rental , car rental hyderabad, car hire hyderabad,car rental bangalore, car hire bangalore, Bangalore to Coorg car Rental, Bangalore to Mysore car Rental, Bangalore to Ooty car Rental, car rental, car hire, car rental near, outstation cabs, outstation car rental, outstation cabs one way, outstation cabs booking, car booking outstation, Bangalore to Chikmagalur cabs, outstation cabs hyderabad, outstation car rentals hyderabad, outstation cabs one way hyderabad, hyderabad to karimnagar cabs, bangalore to mysore cab, hyderabad to vijayawada cabs, hyderabad to warangal cabs,bangalore to coorg cab,bangalore to ooty cab, bangalore to nandi hills cab, cars, Bangalore to Pondicherry cabs, bangalore to tirupati cab, outstation cabs bangalore, outstation car rentals bangalore, cabs from hyderabad to srisailam, hyderabad to bangalore cab, Bangalore to Kodaikanal cabs, Bangalore to Chennai cabs, Bangalore to Wayanad cabs ' },
            { name: "Viewport", content: "width=device-width"},
            { property: "og:image", content: 'https://zyppysimages.s3.ap-south-1.amazonaws.com/rsz_zyplogo.png'},
            { property: "og:image:secure_url", content: 'https://zyppysimages.s3.ap-south-1.amazonaws.com/rsz_zyplogo.png'},
            { property: "og:image:type", content: "image/png"},
            { property: "og:image:width", content: "300"},
            { property: "og:image:height", content: "200" },
            { property: "og:image:alt", content: "zyppys" },
            { property: "og:type", content: "website" },
            { property: "og:title", content: "Best Self Drive Car Rental in India" },
            { property: "og:description", content: "Best Car Rental Marketplace in India" },
            { property: "og:url", content: "https://zyppys.com/" },
            { property: "og:site_name", content: "Zyppys" },
            { property: "og:locale", content: "en_US" }
          ]}
          script={[
            { "type": "application/ld+json", "dangerouslySetInnerHTML":`${{ __html: data }}` },
            // AIzaSyDmSzYU3JlM-AjP_XL9spDTO2A7iWfilUg
            // AIzaSyAEarG8tKd2cFXWtDkAfBOrymFUCfjuFok
            { "src": "https://maps.googleapis.com/maps/api/js?key=AIzaSyDrm-YN3aa0Lj3VMz-hD0_IExL2BYZ06qA&libraries=places", "type": "text/javascript" },
            { "src": "https://checkout.razorpay.com/v1/checkout.js", "type": "text/javascript" },
            // Uncomment whille rolling to prod this is for conversion
            // {"src": "https://www.googletagmanager.com/gtag/js?id=AW-806920639", "type":"text/javascript" },
            // {"src":"https://widget.flowxo.com/embed.js", "data-fxo-widget":"eyJ0aGVtZSI6IiM3NDBEQ0UiLCJ3ZWIiOnsiYm90SWQiOiI1Y2I0NmRlNjk0OGI3NDAwMjYyN2ZlYmIiLCJ0aGVtZSI6IiM3NDBEQ0UiLCJsYWJlbCI6Ildhbm5hIENoYXQhIn0sIndlbGNvbWVUZXh0IjoiTmVlZCBIZWxwPyJ9", "async":true ,"type": "text/javascript"},
            // {"src":"//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", "async":true, "type": "text/javascript" },
          ]}
          link={[
            { "rel":"canonical", "href":"https://zyppys.com/"}
          ]}
          />
     { this.state.coronaDisplay === true &&   <IndexWrapper>
          <NavBar />
          <CoronaDisplay />
     </IndexWrapper> }

     {this.state.coronaDisplay === false && <IndexWrapper>
        {/* <Helmet
          title = "Self-Drive Car Rental In India : Outstation Cabs | Rent A Car | Car Hire Online | Outstation Taxi Booking Service | Airport Transfers | Book Hourly Rental Car - ZYPPYS"
          meta={[
            { name: 'description', content: 'Self Drive Car Rental In India - Outstation Cabs - Airport Transfer Services - Hourly Rental Car : Book best Self-drive car rentals online, hire Self drive cars without driver, Outstation cabs, Outstation taxi, Airport transfer services and Hourly rental cars at affordable prices at ZYPPYS in India.' },
            { name: 'keywords', content: 'Zyypys, Car Rental, car rental near me, car rental app, car rental bangalore, car rental hyderabad, Roadtrip, Outstation Cabs, Road Travel, Chauffeur Driven Cars, Rental Cars, Cheap Rental Cars, Vacation Rentals, Outstation Rentals, Bike Rentals, Aha Taxis, Revv, Zoomcar, Avis, Hertz, Gozo Cabs, Savaari, Taxi Bazaar, Quick Ride, Car Pooling, Car sharing, Travel, Road travel, Airport Taxi, Self Drive Cars, Car Rentals, self drive car hire bangalore,self drive car rental bangalore ,self drive hire bangalore, self drive rental bangalore,self drive car hire hyderabad,self drive car rental hyderabad ,self drive hire hyderabad, self drive rental hyderabad,self drive hire cars ,self drive car rental ,self drive hire , self drive rental , car rental hyderabad, car hire hyderabad,car rental bangalore, car hire bangalore, Bangalore to Coorg car Rental, Bangalore to Mysore car Rental, Bangalore to Ooty car Rental, car rental, car hire, car rental near, outstation cabs, outstation car rental, outstation cabs one way, outstation cabs booking, car booking outstation, Bangalore to Chikmagalur cabs, outstation cabs hyderabad, outstation car rentals hyderabad, outstation cabs one way hyderabad, hyderabad to karimnagar cabs, bangalore to mysore cab, hyderabad to vijayawada cabs, hyderabad to warangal cabs,bangalore to coorg cab,bangalore to ooty cab, bangalore to nandi hills cab, cars, Bangalore to Pondicherry cabs, bangalore to tirupati cab, outstation cabs bangalore, outstation car rentals bangalore, cabs from hyderabad to srisailam, hyderabad to bangalore cab, Bangalore to Kodaikanal cabs, Bangalore to Chennai cabs, Bangalore to Wayanad cabs ' },
            { name: "Viewport", content: "width=device-width"}
          ]}
          script={[
            { "type": "application/ld+json", "dangerouslySetInnerHTML":`${{ __html: data }}` },
            // AIzaSyDmSzYU3JlM-AjP_XL9spDTO2A7iWfilUg
            // AIzaSyAEarG8tKd2cFXWtDkAfBOrymFUCfjuFok
            { "src": "https://maps.googleapis.com/maps/api/js?key=AIzaSyDrm-YN3aa0Lj3VMz-hD0_IExL2BYZ06qA&libraries=places", "type": "text/javascript" },
            { "src": "https://checkout.razorpay.com/v1/checkout.js", "type": "text/javascript" },
            // Uncomment whille rolling to prod this is for conversion
            // {"src": "https://www.googletagmanager.com/gtag/js?id=AW-806920639", "type":"text/javascript" },
            {"src":"https://widget.flowxo.com/embed.js", "data-fxo-widget":"eyJ0aGVtZSI6IiM3NDBEQ0UiLCJ3ZWIiOnsiYm90SWQiOiI1Y2I0NmRlNjk0OGI3NDAwMjYyN2ZlYmIiLCJ0aGVtZSI6IiM3NDBEQ0UiLCJsYWJlbCI6Ildhbm5hIENoYXQhIn0sIndlbGNvbWVUZXh0IjoiTmVlZCBIZWxwPyJ9", "async":true ,"type": "text/javascript"},
            // {"src":"//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js", "async":true, "type": "text/javascript" },
          ]}
          /> */}
            {/* <script> 
              { `
              (window.adsbygoogle = window.adsbygoogle || []).push({ google_ad_client: "ca-pub-3397827005717908", enable_page_level_ads: true});
              `}
            </script> */}
        {/* <div className={css`${tw``}`} > */}
        <NavBar />
        {/* <MessengerCustomerChat
            pageId="385893318286490"
            htmlRef="messenger"
            appId="333760090590652"
            greetingDialogDisplay="show"
            loggedInGreeting="Say hi to get started"
            htmlRef="FBCC"
            shouldShowDialog={true}
          /> */}
          
          <NewSectionOne 
            showRentalOptions={() => {this.showTravelChoices()}}
            handleFormEdit={(type) => this.handleFormEdit(type)} 
            popularRoutes={this.state.popularRoutes}
            />
          {/* <SectionOne/> */}
          {/* <SectionTwo /> */}
          <SectionThree/>
          {/* <SectionFour/> */}
          <SectionFive/>
          <SectionSix/>
          <Footer onPlacePress={(type,from,to)=>{this.handlePlacePress(type,from,to)}}/>
          {/* {typeof window !== 'undefined' && (window.location.href === "https://development.zyppys.com/" || window.location.href === "https://development.zyppys.com/index" || window.location.href === "https://development.zyppys.com" || window.location.href === "http://localhost:8000/" || window.location.href === "https://zyppys.com/" || window.location.href === "https://zyppys.com/index" || window.location.href === "https://zyppys.com") &&

<div className={css`${tw`pb-8 bg-zyppysc `}`}>
  <Row justifyBetween className={css`${tw`w-full h-full flex pt-10`}`}>

    <h1>Self-drive Car Rental</h1>
    <p><a href="https://zyppys.com/self-drive-car-rental">Self-drive car rental</a> from <a href="https://zyppys.com/">ZYPPYS</a> has got everyone hooked. Traveling has never been so easy, imagine going around the city on your own terms, without having to wait impatiently for your vehicle to arrive and adjust with other fellow co-passengers! Are you searching for the best self-drive car rentals near me? Now you donâ€™t have to search long and hard as ZYPPYS does it for you! The process is simple; all you have to do is visit the website and <a href="https://zyppys.com/self-drive-car-rental">book car rental online</a> right here right now, to get set go to your destination.  {!this.state.readMore.includes('1') && <div className={css`${tw` text-anchorLink underline cursor-pointer`}`} onClick={() => { this.setState({ readMore: this.state.readMore + '1' }); }}>Read more</div>}</p>
    {this.state.readMore.includes('1') && <div>
      <h2>Rent a Car</h2>
      <p><a href="https://zyppys.com/self-drive-car-rental">Rent a car</a> for a day, week or month and ZYPPYS gives you the option to choose the car of your choice.  I bet traveling around for your business trips can never be easy, especially when you have to kowtow as per your driverâ€™s whim, haggle unnecessarily about the price as there is no transparency about the price. When it comes to rent a car options ZYPPYS ensures you are your own boss.
<h2>Car Hire</h2>
        <a href="https://zyppys.com/self-drive-car-rental">Car hire</a> services make the monarch of all the roads you survey! Imagine you being the driver, traversing the chartered or unchartered territories with a carefree disdain. Well, thatâ€™s what traveling is all about right?   <a href="https://zyppys.com/self-drive-car-rental">Hire a car</a> for a day, week or month on the ZYPPYS website and enjoy the wind in your hair as you drive a convertible or any car you want.
<h1>Self Drive Cars</h1>
        <p><a href="https://zyppys.com/self-drive-cars">Self-drive cars</a> from ZYPPYS has your traveling plans sorted! Try the <a href="https://zyppys.com/self-drive-cars">best self-drive cars online</a> to move around and visit as many stops as you want, whether it is townâ€™s best cafÃ© or the most popular museum or maybe the office in the city near you!  The time is ripe to chum up with <a href="https://zyppys.com/self-drive-cars">Self-driving cars</a> and slay your travel goals. </p>
        <h2>Self Drive Car Hire</h2>
        <p><a href="https://zyppys.com/self-drive-cars">Self-drive car hire</a> is a driverâ€™s delight.  Travel <a href="https://zyppys.com/self-drive-cars">car hires</a> facilities are so pocket-friendly, you will wonder whether you read that right! Yup, thatâ€™s right! The website is worth visiting, the simplicity of the entire exercise can stump you! If it is so simple why havenâ€™t you heard about it before! ZYPPYS started its journey from 2016 and there was no looking back!  Just <a href="https://zyppys.com/self-drive-cars">hire self-drive cars</a> for a day, week or month without driver online and you do not have to continuously book cars, yes thatâ€™s right you may be the proud owner of a luxe car for a month and at a nominal price. </p>
        <h2>Book Self Drive Cars</h2>
        <p>ZYPPYS made car rentals big news in the mobile-savvy age and helped boost the user experience. This car rental website helps you book and a luxury car ala Mercedes in a matter of minutes. This website has successfully eradicated long wait hours and unnecessary paperwork that one often associates while you <a href="https://zyppys.com/self-drive-cars">book self-drive car hire</a>. You can <a href="https://zyppys.com/self-drive-cars">book the best self-drive cars</a> for a day week or month and get set go to your favorite destinations. </p>
      </p></div>}
    <h1>Outstation Cabs</h1>
    <p><a href="https://zyppys.com/outstation-cabs">Outstation cabs</a> are exactly what you need if you want to travel somewhere out of your city.  The outstation cabs from ZYPPYS offer you a choice of convenience.  A sudden business schedule can create problems in your schedule  The <a href="https://zyppys.com/outstation-cabs">best outstation cabs</a> makes it easier for you, you just book a car and stay calm and unruffled as the <a href="https://zyppys.com/outstation-cabs">best outstation cab service</a> sorts all your schedule so that you can tick off all the places, you considered visiting.  Book the best outstation cabs near me to ensure you travel smart! {!this.state.readMore.includes('2') && <div className={css`${tw` text-anchorLink underline cursor-pointer`}`} onClick={() => { this.setState({ readMore: this.state.readMore + '2' }); }}>Read more</div>}</p>

    {this.state.readMore.includes('2') && <div><h2>Outstation Cab Booking</h2>
      <p>If you have tried other car rental and it hasnâ€™t worked for you, you can try the <a href="https://zyppys.com/outstation-cabs">best outstation cab booking online</a> and explore unbelievable prices at the car rental marketplace.  ZYPPYS offers some amazing offers and resolves all road issues in one easy flourish. Yes, just try c<a href="https://zyppys.com/outstation-cabs">ar booking at the outstation</a> and then they will provide just the car you need as soon as possible.  Even if you are planning to travel to different cities the <a href="https://zyppys.com/outstation-cabs">intercity cab booking</a> can provide individualized solutions.  Try <a href="https://zyppys.com/outstation-cabs">car booking at the outstation</a> and you would never have experienced a smoother journey.</p>
      <h2>Outstation Taxi Booking Service</h2>
      <p><a href="https://zyppys.com/outstation-cabs">The outstation taxi booking service</a> makes luxury travel a distinct possibility at a very affordable price.  <a href="https://zyppys.com/outstation-cabs">Outstation taxi service</a> enables a customer traveling to different cities not visit 10 websites to travel from one spot to another.  One website does everything for you, catering to your travel requirements, be it city rentals, airport travel to outstation travel.   Yes, <a href="https://zyppys.com/outstation-cabs">outstation taxi booking</a> makes movement so easy for you. Explore <a href="https://zyppys.com/outstation-cabs">online outstation taxi booking</a> to get the right car for your individualized needs.</p>
      <h2>Outstation Car Rental</h2>
      <p>The <a href="https://zyppys.com/outstation-cabs">outstation car rental</a>  website is a platform to find the right car for you wherever you are in India. Not only the customers, the aggregators & fleet owners are also set to gain from the platform as it helps generate more revenue and build customer loyalty and provide superlative services to the discerning customer. </p>
    </div>}
    <h1>Airport transfer services</h1>
    <p>If you are a busy traveler, and living out of suitcases then traveling To and fro from airports can be a task in itself.  But they do not have to be as troublesome as they are made out to be, in fact, they can be made super simple and seamless! The commute in style with the best <a href="https://zyppys.com/">airport travel services</a>. ZYPPYS offer the best <a href="https://zyppys.com/">airport transfer services online</a>. Visit the website, find your vehicle and click the rent button.</p>
    <h1>Hourly Rental Car</h1>
    <p>Commuting has never been this easy, and even if you want to book your favorite car for an hour ZYPPYS has the facilities for the busy bee traveler. An <a href="https://zyppys.com/">hourly rental car</a> is an answer to all those mini travel hassles. Book for an hour and save valuable time and money! Yes, you save time as you zip around the city without wheeling away precious minutes waiting for public transport to turn up. The <a href="https://zyppys.com/">best hourly rental cars online</a> allow you the privilege to make time for other things, as you move from one spot to another in double-quick time.  It is the best way to indulge in quality me-time as you fulfill all your travel aspirations in a good time. {!this.state.readMore.includes('3') && <div className={css`${tw` text-anchorLink underline cursor-pointer`}`} onClick={() => { this.setState({ readMore: this.state.readMore + '3' }); }}>Read more</div>} </p>
    {this.state.readMore.includes('3') && <div>
      <p>ZYPPYS plans to provide cars on a global scale and minimize mobility hurdles. It was launched in 2016 and since then has gained from strength to strength. It provides the discerning traveler with the best traveling services. There was no method to the madness in the travel industry, customers wanted quality services, but they never knew exactly where to look for it. In came ZYPPYS to introduce and acquaint customers to organized traveling. It meant no longer waiting in long queues for car hire, unprofessionalism on the part of drivers, problematic outstation travels. With 22 top car rental companies joining the bandwagon, things are only going to get bigger and better. </p>
      <p>ZYPPYS is a one-stop-shop for realizing all your travel goals; they have every car for your need, chauffeur driven to self-drive car rentals, everything to make the journey completely memorable. ZYPPYS will impact the way you perceive and think about travel.  Think big and travel smart, which should be our mantra, modern-day travel with car rentals is fun, interesting, convenient and exhilarating.  All I can say is hop on board and enjoy the ride!</p></div>}




  </Row>
</div>


} */}
{/* <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: data }}
    /> */}
        {/* </div> */}

        <BlackOverlay 
          active={this.state.showOverlay} 
          onClick={()=>{this.allFalse();this.setState({isFocus:false});}}>
            
          <RentingChoicesModal 
            active={this.state.showChoiceModal} 
          
            onClick={this.handleRentalTypeChange}

          />
          {/* <CarChoicesModal
          active={this.state.showCarChoicesModal}

          /> */}
          {/* <SliderModal active={this.state.showChoiceModal}>
            <RentingChoicesWrapper>    n 
              <h3 className={css`${tw`w-full text-xl tracking-tight font-medium text-black text-grey-dark sticky`}`}>What's your <span className={css`${tw`block font-bold text-purple`}`}>Choice of Rental?</span></h3>
              <RentingChoiceButton
                onClick={() => this.handleRentalTypeChange(1)}  
                icon={OSCabIcon}
                title='Outstation Cabs'
                description='I wanna travel between cities, with a chauffeur'
              />
              <RentingChoiceButton
                onClick={() => this.handleRentalTypeChange(2)}  
                icon={SDCabIcon}
                title='Self Drive Cars'
                description='I want to rent a car to drive myself and go anywhere I want.'
      
              />
              <RentingChoiceButton
                onClick={() => this.handleRentalTypeChange(3)} 
                icon={ATCabIcon}
                title='Airport Transfers'
                description='I want to get to an airport (or) get home from an airport in a chauffeur driven car.'
          
              />
              <RentingChoiceButton
                onClick={() => this.handleRentalTypeChange(5)}  
                icon={HRCabIcon}
                title='Hourly Rentals'
                description='I want a chauffeur driven car to stay with me for a certain duration to roam inside the city.'
              />
            </RentingChoicesWrapper>
          </SliderModal> */}

          {(this.state.isPickupEditing || this.state.isDestEditing) &&

            <PlacesModal
                active={this.state.showPlacesModal}
                isPickup={this.state.isPickupEditing}
                isDest={this.state.isDestEditing}
                isRoundtrip={
                  // Checks if Roundtrip is true from store
                  this.props.ride.measureLookupId === '100010001'
                } 
                isFocus={this.state.isFocus}
                onClick={()=> {this.setState({showPlacesModal: false, showOverlay: false, isFocus:false});}}/>
          }
          <DateTime
            active={this.state.showDatesModal}
            isStartDate={this.state.editingStartDate}
            onClick={() => { this.setState({ showDatesModal: false, showOverlay: false }) }} />

          {/*<NewDateTime isStartDate={true} isEndDate={false} ref="datesStart" afterChange={()=>{}}/>
            <NewDateTime isStartDate={false} isEndDate={true} ref="datesEnd" afterChange={()=>{}}/>*/}


          <PackagesModal
            active={this.state.showPackagesModal}
            type = {this.state.packageModalType}
            onClick={this.handleRentalTypeChange} 
            airportTypeClick= {this.airportTypeChange}/>
        </BlackOverlay>
          </IndexWrapper> }
      </div>
    );

  }


  showChoiceModal() {
    this.setState({ showChoiceModal: true });
  }

  hideChoiceModal() {
    this.setState({ showChoiceModal: false });
  }

  showTravelChoices() {
    // this.allFalse();
    console.log('Show Travel Choices');
    this.setState({ showOverlay: true }, this.showChoiceModal);
  }

  hideTravelChoices() {
    console.log('Hide Travel Choices');
    this.setState({ showChoiceModal: false }, this.setState({ showOverlay: false }));
  }

  allFalse() {
    console.log('All False called');
    this.setState({
      showOverlay: false,
      showPlacesModal: false,
      editingStartDate: false,
      editingEndDate: false,
      isPickupEditing: false,
      isDestEditing: false,
      showDatesModal: false,
      showPackagesModal: false,
      showChoiceModal: false,
    })
  }

  // showPlacesModal(){
  //   //for callback function
  //   let self = this;
  //   this.setState({showOverlay: true}, 
  //     function(){
  //       self.setState({showPlacesModal: true});
  //     }
  //   );
  // }

  // hidePlacesModal(){
  //   let self = this;
  //   this.setState({ showPlacesModal: false  },
  //     function () {
  //       self.setState({ showOverlay: false });
  //     }
  //   );
  // }

  handleSelect = (address,isPickup) => {
    
    let self = this;
    console.log(address)
    geocodeByAddress(address)
    .then(results => {
        ;
        console.log(results[0]);
        if(results[0].address_components.length>1){
        geocodeByAddress(results[0].address_components[1].long_name)
        .then(results1 => {
            if (isPickup && results1[0]) {
                this.updatePickupLocation(results[0],results1[0]);
                this.setState({ address: "" });
            }
            else if(isPickup){
                this.updatePickupLocation(results[0]);
                this.setState({ address: "" });
            }
            else {
                this.updateDestLocation(results[0]);
                this.setState({ address: "" });
            }
            getLatLng(results[0])
        })
        .then(latLng => console.log('Success', latLng))
        .catch(error => console.error('Error', error));
    }
    // if (this.props.isPickup) {
    //     this.updatePickupLocation(results[0]);
    //     this.setState({ address: "" });
    // }
    // else {
    //     this.updateDestLocation(results[0]);
    //     this.setState({ address: "" });
    // }
    //         getLatLng(results[0])
            })
        .then(latLng => console.log('Success', latLng))
        .catch(error => console.error('Error', error));
    this.setState({ formEditing: false, });
};

updatePickupLocation = (details,altLoc) => {
  let city = '';
  let flag = 0;
  // eslint-disable-next-line
  analytics.track('Pickup Changed:', { category: 'clicks', label: details.formatted_address });
  this.setState({ pickupAddress: details.formatted_address });
  this.props.dispatch(updatePickupLocation({
      name: details.formatted_address,
      locLat: details.geometry.location.lat(),
      locLng: details.geometry.location.lng()
  }));
  //Finding city's name from details object
  let types = ['locality', 'administrative_area_level_2', 'administrative_area_level_1']
  if(details.address_components.length>1){
  for (let i = 0; i < 3; i++) {
      for (let j = 0; j < details.address_components.length; j++) {
          if (details.address_components[j].types[0] === types[i]) {
              city = details.address_components[j].long_name;
              flag = 1;
              break;
          }
      }
      if (flag === 1) {
          break;
      }
  }
}
else{
  city = details.address_components[0].long_name;
          flag = 1;
}
  if (city === "Bangalore" || city === "Bengaluru Rural" || city === "Bengaluru Urban" || city === "Bangalore Rural" || city === "Bangalore Urban") {
      city = "Bengaluru";
  }
  if (city === "Secunderabad") {
      city = "Hyderabad";
  }
  
  this.setState({ pickupCity: city });
  if(altLoc){
  this.props.dispatch(fetchLocationByLatLong(city , altLoc.address_components[0].long_name));
}
else{
  let dummy="";
  this.props.dispatch(fetchLocationByLatLong(city,dummy));
}
  this.props.dispatch(addFirstStop({
      city: city,
      name: details.formatted_address,
      latitude: details.geometry.location.lat(),
      longitude: details.geometry.location.lng()
  }));
  if (this.state.isRoundtrip) {
      this.props.dispatch(editStop(2, {
          city: city,
          name: details.formatted_address,
          latitude: details.geometry.location.lat(),
          longitude: details.geometry.location.lng(),
          cityLat: '',
          cityLng: ''
      }));
  }
  // this.getLatLngOfCity(city,'pickup');
}


updateDestLocation = (details) => {
  let destCity = '';
  let flag = 0, add = '';
  let formatted_address = '';
  let address = details.address_components;
  if (this.state.pickupAddress === null) {
      this.props.dispatch(pushStopAtIndex(1, {
          seqId: 2,
          name: details.formatted_address,
          latitude: details.geometry.location.lat(),
          longitude: details.geometry.location.lng()
      }));
  }

  else if (this.state.destinationAddress === null) {
      this.props.dispatch(addStop({
          name: details.formatted_address,
          latitude: details.geometry.location.lat(),
          longitude: details.geometry.location.lng()
      }));

      //adding first stop at the last if dest is entered after toggling to round trip
      if (this.props.isRoundtrip) {
          this.props.dispatch(addStop(this.props.ride.stops[0]));
      }
  }

  else {
      this.props.dispatch(editStop(1, {
          name: details.formatted_address,
          latitude: details.geometry.location.lat(),
          longitude: details.geometry.location.lng()
      }));
  }
  // eslint-disable-next-line
  analytics.track('Destination Changed:', { category: 'clicks', label: details.formatted_address });
  this.setState({ destinationAddress: details.formatted_address });

  this.props.dispatch(updateDestLocation({
      name: details.formatted_address,
      locLat: details.geometry.location.lat(),
      locLng: details.geometry.location.lng()
  }));

  // this.setState({ destinationAddress: details.formatted_address });

  //Finding city's name from details object
  let types = ['locality', 'administrative_area_level_2', 'administrative_area_level_1']
  for (let i = 0; i < 3; i++) {
      for (let j = 0; j < details.address_components.length; j++) {
          if (details.address_components[j].types[0] === types[i]) {
              destCity = details.address_components[j].long_name;
              flag = 1;
              break;
          }
      }
      if (flag === 1) {
          break;
      }
  }
  if (destCity === "Bangalore" || destCity === "Bengaluru Rural" || destCity === "Bengaluru Urban" || destCity === "Bangalore Rural" || destCity === "Bangalore Urban") {
      destCity = "Bengaluru";
  }
  if (destCity === "Secunderabad") {
      destCity = "Hyderabad";
  }
  this.setState({ destinationCity: destCity });
  this.getLatLngOfCity(destCity, 'dest');
}


getLatLngOfCity = (city, type) => {
  let self = this;
  Geocode.fromAddress(city)
      .then(json => {
          let location = json.results[0].geometry.location;
          
          if (type === 'pickup') {
              self.props.dispatch(updateCityOfStop({
                  city: city,
                  cityLat: location.lat,
                  cityLng: location.lng
              }, 0));
          }
          else {
              self.props.dispatch(updateCityOfStop({
                  city: city,
                  cityLat: location.lat,
                  cityLng: location.lng
              }, 1));
              self.props.dispatch(updateDestCity({
                  city: city,
                  cityLat: location.lat,
                  cityLng: location.lng
              }));
          }
      })
}
} 


const mapStateToProps = (state) => ({
  ride: state.ride,
  stops: state.ride.stops,
  isUserLoggedIn: state.user.isLoggedIn,
  ipAddress: state.order.IP
})

export default connect(mapStateToProps)(withLocation(index));


injectGlobal(`.row { 
  margin-right: auto;
  margin-left: auto;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-flow: row wrap;
      flex-flow: row wrap; }
       max-width: 70rem;
    @media(min-width: 1000px){
        padding-left: 5rem;
        padding-right: 5rem;
    }
    @media(min-width: 640px){
        padding-left: 1.5rem;
        padding-right: 1.5rem;
    }
    @media(min-width: 320px){
        padding-left: 1rem;
        padding-right: 1rem;
    }
  `);

injectGlobal(`
    p{
      margin-bottom: 0;
      margin-top:0;
    }
`);


// const Component = styled.div`
//  ${tw``};
// `

// injectGlobal(const row = css`
//   ${tw`px-20 flex flex-wrap mx-auto`};
// `)
// const row = css`
//  ${tw`px-20 flex flex-wrap mx-auto`};
// `

/*! normalize.css v5.0.0 | MIT License | github.com/necolas/normalize.css */

/**
 * 1. Change the default font family in all browsers (opinionated).
 * 2. Correct the line height in all browsers.
 * 3. Prevent adjustments of font size after orientation changes in
 *    IE on Windows Phone and in iOS.
 */


/* Document
   ========================================================================== */

injectGlobal(`html {
  font-family: 'Chromatica', Helvetica, Arial, sans-serif; /* 1 */
  text-rendering: optimizeLegibility;
	-webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale; 
  line-height: 1.618; /* 2 */
  -ms-text-size-adjust: 100%; /* 3 */
  -webkit-text-size-adjust: 100%; /* 3 */
  font-size: 14px;
  @media 
  (-webkit-min-device-pixel-ratio: 1.5), 
  (min-resolution: 144dpi){ 
      /* Retina-specific stuff here */
      font-size: 14px;
  }
}`);

/* Sections
   ========================================================================== */


injectGlobal(`div{
  box-sizing: border-box;
}`)
/**
 * Remove the margin in all browsers (opinionated).
 */

injectGlobal(`body {
  margin: 0;
}`);

/**
 * Add the correct display in IE 9-.
 */

injectGlobal(`article,
aside,
footer,
header,
nav,
section {
  display: block;
}`);

/**
 * Correct the font size and margin on `h1` elements within `section` and
 * `article` contexts in Chrome, Firefox, and Safari.
 */

injectGlobal(`h1 {
  font-size: 2em;
}`);

/* Grouping content
   ========================================================================== */

/**
 * Add the correct display in IE 9-.
 * 1. Add the correct display in IE.
 */

injectGlobal(`figcaption,
figure,
main { /* 1 */
  display: block;
}`);

/**
 * Add the correct margin in IE 8.
 */

injectGlobal(`figure {
  margin: 1em 40px;
}`);

/**
 * 1. Add the correct box sizing in Firefox.
 * 2. Show the overflow in Edge and IE.
 */

injectGlobal(`hr {
  box-sizing: border-box; /* 1 */
  height: 0; /* 1 */
  overflow: visible; /* 2 */
}`);

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */

injectGlobal(`pre {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}`);

/* Text-level semantics
   ========================================================================== */

/**
 * 1. Remove the gray background on active links in IE 10.
 * 2. Remove gaps in links underline in iOS 8+ and Safari 8+.
 */

injectGlobal(`a {
  background-color: transparent; /* 1 */
  -webkit-text-decoration-skip: objects; /* 2 */
}`);

/**
 * Remove the outline on focused links when they are also active or hovered
 * in all browsers (opinionated).
 */

injectGlobal(`a:active,
a:hover {
  outline-width: 0;
}`);

/**
 * 1. Remove the bottom border in Firefox 39-.
 * 2. Add the correct text decoration in Chrome, Edge, IE, Opera, and Safari.
 */

injectGlobal(`abbr[title] {
  border-bottom: none; /* 1 */
  text-decoration: underline; /* 2 */
  text-decoration: underline dotted; /* 2 */
}`);

/**
 * Prevent the duplicate application of `bolder` by the next rule in Safari 6.
 */

injectGlobal(`b,
strong {
  font-weight: inherit;
}`);

/**
 * Add the correct font weight in Chrome, Edge, and Safari.
 */

injectGlobal(`b,
strong {
  font-weight: bolder;
}`);

/**
 * 1. Correct the inheritance and scaling of font size in all browsers.
 * 2. Correct the odd `em` font sizing in all browsers.
 */

injectGlobal(`code,
kbd,
samp {
  font-family: monospace, monospace; /* 1 */
  font-size: 1em; /* 2 */
}`);

/**
 * Add the correct font style in Android 4.3-.
 */

injectGlobal(`dfn {
  font-style: italic;
}`);

/**
 * Add the correct background and color in IE 9-.
 */

injectGlobal(`mark {
  background-color: #ff0;
  color: #000;
}`);

/**
 * Add the correct font size in all browsers.
 */

injectGlobal(`small {
  font-size: 80%;
}`);

/**
 * Prevent `sub` and `sup` elements from affecting the line height in
 * all browsers.
 */

injectGlobal(`sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}`);

injectGlobal(`sub {
  bottom: -0.25em;
}`);

injectGlobal(`sup {
  top: -0.5em;
}`);

/* Embedded content
   ========================================================================== */

/**
 * Add the correct display in IE 9-.
 */

injectGlobal(`audio,
video {
  display: inline-block;
}`);

/**
 * Add the correct display in iOS 4-7.
 */

injectGlobal(`audio:not([controls]) {
  display: none;
  height: 0;
}`);

/**
 * Remove the border on images inside links in IE 10-.
 */

injectGlobal(`img {
  border-style: none;
}`);

/**
 * Hide the overflow in IE.
 */

injectGlobal(`svg:not(:root) {
  overflow: hidden;
}`);

/* Forms
   ========================================================================== */

/**
 * 1. Change the font styles in all browsers (opinionated).
 * 2. Remove the margin in Firefox and Safari.
 */

injectGlobal(`button,
input,
optgroup,
select,
textarea {
  // font-family: sans-serif; /* 1 */
  // font-size: 100%; /* 1 */
  // line-height: 1.15; /* 1 */
  // margin: 0; /* 2 */
}`);

/**
 * Show the overflow in IE.
 * 1. Show the overflow in Edge.
 */

injectGlobal(`button,
input { /* 1 */
  overflow: visible;
}`);

/**
 * Remove the inheritance of text transform in Edge, Firefox, and IE.
 * 1. Remove the inheritance of text transform in Firefox.
 */

injectGlobal(`button,
select { /* 1 */
  text-transform: none;
}`);

/**
 * 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`
 *    controls in Android 4.
 * 2. Correct the inability to style clickable types in iOS and Safari.
 */

injectGlobal(`button,
html [type="button"], /* 1 */
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; /* 2 */
}`);

/**
 * Remove the inner border and padding in Firefox.
 */

injectGlobal(`button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  border-style: none;
  padding: 0;
}`);

/**
 * Restore the focus styles unset by the previous rule.
 */

injectGlobal(`button:-moz-focusring,
[type="button"]:-moz-focusring,
[type="reset"]:-moz-focusring,
[type="submit"]:-moz-focusring {
  outline: 1px dotted ButtonText;
}`);

/**
 * Change the border, margin, and padding in all browsers (opinionated).
 */

injectGlobal(`fieldset {
  border: 1px solid #c0c0c0;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}`);

/**
 * 1. Correct the text wrapping in Edge and IE.
 * 2. Correct the color inheritance from `fieldset` elements in IE.
 * 3. Remove the padding so developers are not caught out when they zero out
 *    `fieldset` elements in all browsers.
 */

injectGlobal(`legend {
  box-sizing: border-box; /* 1 */
  color: inherit; /* 2 */
  display: table; /* 1 */
  max-width: 100%; /* 1 */
  padding: 0; /* 3 */
  white-space: normal; /* 1 */
}`);

/**
 * 1. Add the correct display in IE 9-.
 * 2. Add the correct vertical alignment in Chrome, Firefox, and Opera.
 */

injectGlobal(`progress {
  display: inline-block; /* 1 */
  vertical-align: baseline; /* 2 */
}`);

/**
 * Remove the default vertical scrollbar in IE.
 */

injectGlobal(`textarea {
  overflow: auto;
}`);

/**
 * 1. Add the correct box sizing in IE 10-.
 * 2. Remove the padding in IE 10-.
 */

injectGlobal(`[type="checkbox"],
[type="radio"] {
  box-sizing: border-box; /* 1 */
  padding: 0; /* 2 */
}`);

/**
 * Correct the cursor style of increment and decrement buttons in Chrome.
 */

injectGlobal(`[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}`);

/**
 * 1. Correct the odd appearance in Chrome and Safari.
 * 2. Correct the outline style in Safari.
 */

injectGlobal(`[type="search"] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}`);

/**
 * Remove the inner padding and cancel buttons in Chrome and Safari on macOS.
 */

injectGlobal(`[type="search"]::-webkit-search-cancel-button,
[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}`);

/**
 * 1. Correct the inability to style clickable types in iOS and Safari.
 * 2. Change font properties to `inherit` in Safari.
 */

injectGlobal(`::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}`);

/* Interactive
   ========================================================================== */

/*
 * Add the correct display in IE 9-.
 * 1. Add the correct display in Edge, IE, and Firefox.
 */

injectGlobal(`details, /* 1 */
menu {
  display: block;
}`);

/*
 * Add the correct display in all browsers.
 */

injectGlobal(`summary {
  display: list-item;
}`);

/* Scripting
   ========================================================================== */

/**
 * Add the correct display in IE 9-.
 */

injectGlobal(`canvas {
  display: inline-block;
}`);

/**
 * Add the correct display in IE.
 */

injectGlobal(`template {
  display: none;
}`);

/* Hidden
   ========================================================================== */

/**
 * Add the correct display in IE 10-.
 */

injectGlobal(`[hidden] {
  display: none;
}`);